import AvailabilityCheck from './AvailabilityCheck'

export default AvailabilityCheck
